export default __webpack_public_path__ + "locales/si/SingleSignOn.json?hash=0985a5e9472373ee216e1f3b411162a2";